function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

import { useRect } from "@vant/use";
import { loadImageAsync } from "./util";
import { noop } from "../../utils";

var ReactiveListener = /*#__PURE__*/function () {
  function ReactiveListener(_ref) {
    var el = _ref.el,
        src = _ref.src,
        error = _ref.error,
        loading = _ref.loading,
        bindType = _ref.bindType,
        $parent = _ref.$parent,
        options = _ref.options,
        cors = _ref.cors,
        elRenderer = _ref.elRenderer,
        imageCache = _ref.imageCache;

    _classCallCheck(this, ReactiveListener);

    this.el = el;
    this.src = src;
    this.error = error;
    this.loading = loading;
    this.bindType = bindType;
    this.attempt = 0;
    this.cors = cors;
    this.naturalHeight = 0;
    this.naturalWidth = 0;
    this.options = options;
    this.$parent = $parent;
    this.elRenderer = elRenderer;
    this.imageCache = imageCache;
    this.performanceData = {
      loadStart: 0,
      loadEnd: 0
    };
    this.filter();
    this.initState();
    this.render("loading", false);
  }

  _createClass(ReactiveListener, [{
    key: "initState",
    value: function initState() {
      if ("dataset" in this.el) {
        this.el.dataset.src = this.src;
      } else {
        this.el.setAttribute("data-src", this.src);
      }

      this.state = {
        loading: false,
        error: false,
        loaded: false,
        rendered: false
      };
    }
  }, {
    key: "record",
    value: function record(event) {
      this.performanceData[event] = Date.now();
    }
  }, {
    key: "update",
    value: function update(_ref2) {
      var src = _ref2.src,
          loading = _ref2.loading,
          error = _ref2.error;
      var oldSrc = this.src;
      this.src = src;
      this.loading = loading;
      this.error = error;
      this.filter();

      if (oldSrc !== this.src) {
        this.attempt = 0;
        this.initState();
      }
    }
  }, {
    key: "checkInView",
    value: function checkInView() {
      var rect = useRect(this.el);
      return rect.top < window.innerHeight * this.options.preLoad && rect.bottom > this.options.preLoadTop && rect.left < window.innerWidth * this.options.preLoad && rect.right > 0;
    }
  }, {
    key: "filter",
    value: function filter() {
      var _this = this;

      Object.keys(this.options.filter).forEach(function (key) {
        _this.options.filter[key](_this, _this.options);
      });
    }
  }, {
    key: "renderLoading",
    value: function renderLoading(cb) {
      var _this2 = this;

      this.state.loading = true;
      loadImageAsync({
        src: this.loading,
        cors: this.cors
      }, function () {
        _this2.render("loading", false);

        _this2.state.loading = false;
        cb();
      }, function () {
        cb();
        _this2.state.loading = false;
        if (process.env.NODE_ENV !== "production" && !_this2.options.silent) console.warn("[@vant/lazyload] load failed with loading image(".concat(_this2.loading, ")"));
      });
    }
  }, {
    key: "load",
    value: function load() {
      var _this3 = this;

      var onFinish = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : noop;

      if (this.attempt > this.options.attempt - 1 && this.state.error) {
        if (process.env.NODE_ENV !== "production" && !this.options.silent) {
          console.log("[@vant/lazyload] ".concat(this.src, " tried too more than ").concat(this.options.attempt, " times"));
        }

        onFinish();
        return;
      }

      if (this.state.rendered && this.state.loaded) return;

      if (this.imageCache.has(this.src)) {
        this.state.loaded = true;
        this.render("loaded", true);
        this.state.rendered = true;
        return onFinish();
      }

      this.renderLoading(function () {
        var _a, _b;

        _this3.attempt++;
        (_b = (_a = _this3.options.adapter).beforeLoad) == null ? void 0 : _b.call(_a, _this3, _this3.options);

        _this3.record("loadStart");

        loadImageAsync({
          src: _this3.src,
          cors: _this3.cors
        }, function (data) {
          _this3.naturalHeight = data.naturalHeight;
          _this3.naturalWidth = data.naturalWidth;
          _this3.state.loaded = true;
          _this3.state.error = false;

          _this3.record("loadEnd");

          _this3.render("loaded", false);

          _this3.state.rendered = true;

          _this3.imageCache.add(_this3.src);

          onFinish();
        }, function (err) {
          !_this3.options.silent && console.error(err);
          _this3.state.error = true;
          _this3.state.loaded = false;

          _this3.render("error", false);
        });
      });
    }
  }, {
    key: "render",
    value: function render(state, cache) {
      this.elRenderer(this, state, cache);
    }
  }, {
    key: "performance",
    value: function performance() {
      var state = "loading";
      var time = 0;

      if (this.state.loaded) {
        state = "loaded";
        time = (this.performanceData.loadEnd - this.performanceData.loadStart) / 1e3;
      }

      if (this.state.error) state = "error";
      return {
        src: this.src,
        state: state,
        time: time
      };
    }
  }, {
    key: "$destroy",
    value: function $destroy() {
      this.el = null;
      this.src = null;
      this.error = null;
      this.loading = null;
      this.bindType = null;
      this.attempt = 0;
    }
  }]);

  return ReactiveListener;
}();

export { ReactiveListener as default };